import { A11yModule } from '@angular/cdk/a11y';
import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { AutoExpandModule } from '@commons/auto-expand/auto-expand.module';
import { CheckmarkLoaderModule } from '@commons/checkmark-loader/checkmark-loader.module';
import { SocialIconsModule } from '@commons/social-icons/social-icons.module';
import { SvgIconModule } from '@commons/svg-icon/svg-icon.module';
import { I18nDomainCategoryModule } from '@domains/job/i18n-domain-category/i18n-domain-category.module';
import { I18nDomainModule } from '@domains/job/i18n-domain/i18n-domain.module';
import { DotsIndicatorComponent } from '@domains/profile-unlogged/commons/dots-indicator/dots-indicator.component';
import { SectionComponent } from '@domains/profile-unlogged/commons/section/section.component';
import { EducationComponent } from '@domains/profile-unlogged/educations/education/education.component';
import { EducationsComponent } from '@domains/profile-unlogged/educations/educations.component';
import { ExtraExperienceComponent } from '@domains/profile-unlogged/extra-experiences/extra-experience/extra-experience.component';
import { ExtraExperiencesComponent } from '@domains/profile-unlogged/extra-experiences/extra-experiences.component';
import { AddHardSkillComponent } from '@domains/profile-unlogged/hard-skills/add-hard-skill/add-hard-skill.component';
import { HardSkillComponent } from '@domains/profile-unlogged/hard-skills/hard-skill/hard-skill.component';
import { HardSkillsComponent } from '@domains/profile-unlogged/hard-skills/hard-skills.component';
import { I18nLanguageComponent } from '@domains/profile-unlogged/i18n-language/i18n-language.component';
import { I18nProficiencyComponent } from '@domains/profile-unlogged/i18n-proficiency/i18n-proficiency.component';
import { IdentityComponent } from '@domains/profile-unlogged/identity/identity.component';
import { LanguageComponent } from '@domains/profile-unlogged/languages/language/language.component';
import { LanguagesComponent } from '@domains/profile-unlogged/languages/languages.component';
import { LinksComponent } from '@domains/profile-unlogged/links/links.component';
import { PersonalIdentityComponent } from '@domains/profile-unlogged/personal-identity/personal-identity.component';
import { ProExperienceComponent } from '@domains/profile-unlogged/pro-experiences/pro-experience/pro-experience.component';
import { ProExperiencesComponent } from '@domains/profile-unlogged/pro-experiences/pro-experiences.component';
import { ResumeComponent } from '@domains/profile-unlogged/resume/resume.component';
import { SoftSkillsComponent } from '@domains/profile-unlogged/soft-skills/soft-skills.component';
import { TitleComponent } from '@domains/profile-unlogged/title/title.component';
import { I18nWishesComponent } from '@domains/profile-unlogged/wishes/i18n-wishes/i18n-wishes.component';
import { WishesComponent } from '@domains/profile-unlogged/wishes/wishes.component';
import { I18nSoftSkillModule } from '@domains/profile/soft-skills/i18n-soft-skill/i18n-soft-skill.component';

@NgModule({
  imports: [
    A11yModule,
    AutoExpandModule,
    CheckmarkLoaderModule,
    CommonModule,
    FormsModule,
    I18nDomainCategoryModule,
    I18nDomainModule,
    I18nSoftSkillModule,
    LayoutModule,
    MatAutocompleteModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatSelectModule,
    ReactiveFormsModule,
    RouterModule,
    SocialIconsModule,
    SvgIconModule,
  ],
  declarations: [
    AddHardSkillComponent,
    DotsIndicatorComponent,
    EducationComponent,
    EducationsComponent,
    ExtraExperienceComponent,
    ExtraExperiencesComponent,
    HardSkillComponent,
    HardSkillsComponent,
    I18nLanguageComponent,
    I18nProficiencyComponent,
    I18nWishesComponent,
    IdentityComponent,
    LanguageComponent,
    LanguagesComponent,
    LinksComponent,
    PersonalIdentityComponent,
    ProExperienceComponent,
    ProExperiencesComponent,
    ResumeComponent,
    SectionComponent,
    SoftSkillsComponent,
    TitleComponent,
    WishesComponent,
  ],
  exports: [IdentityComponent, ResumeComponent],
})
export class ProfileUnloggedModule {}
